import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { Link } from "react-router-dom";
import styles from "./TemplateGraph.module.css";

const data = [
  { name: "Marketing", sent: 15000, read: 12000 },
  { name: "Utility", sent: 35000, read: 33000 },
  { name: "Auth", sent: 80000, read: 74000 },
];

const TemplatesGraph = () => {
  return (
    <div className="row g-3 mt-3">
      {/* LEFT CARD */}
      <div className="col-md-8">
        <div className="card border-0 shadow-sm">
          <div className="card-body p-3">
            <div className="mb-2">
              <div className="fw-semibold" style={{ fontSize: "12px" }}>
                Template Performance by Category
              </div>
              <div className="text-muted" style={{ fontSize: "11px" }}>
                Sent vs Read volume over the last 30 days
              </div>
            </div>

            <div className={styles.chart}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={data}
                  barGap={6}
                  barCategoryGap={48}
                >
                  <CartesianGrid
                    stroke="#EEF2F7"
                    strokeDasharray="3 6"
                    vertical={false}
                  />
                  <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 11, fill: "#64748B" }}
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 11, fill: "#64748B" }}
                  />
                  <Bar
                    dataKey="sent"
                    fill="#6366F1"
                    radius={[4, 4, 0, 0]}
                    maxBarSize={22}
                  />
                  <Bar
                    dataKey="read"
                    fill="#34D399"
                    radius={[4, 4, 0, 0]}
                    maxBarSize={22}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT CARD */}
      {/* RIGHT CARD */}
<div className="col-md-4">
  <div className={`card border-0 shadow-sm h-100 ${styles.tip}`}>
    <div className="card-body p-3 d-flex flex-column">
      
      {/* Top content */}
      <div>
        <div className={styles.tipTitle}>
          Pro Tip: Rich Media
        </div>

        <div className={styles.tipText}>
          Templates with images or videos have a 45% higher
          engagement rate on WhatsApp and RCS compared to
          text-only.
        </div>
      </div>

      {/* Bottom CTA */}
      {/* <Link className={`mt-auto ${styles.tipBtn}`} to="/dashboard/template">
        Upgrade Templates
      </Link> */}

    </div>
  </div>
</div>

    </div>
  );
};

export default TemplatesGraph;
